// Reusable helpers for adding photos to card face or photozone

export function createPhotoFromImage(image: any) {
  return {
    refId: image.data.refId,
    id: image.data.imageId,
    url: image.data.url,
    size: {
      width: image.width,
      height: image.height,
    },
  };
}

export function setImageOnSelect(
  image: any,
  openImageEditDrawer: () => void,
  isReplacingImage: any,
  updateEditFormats: any,
  firstElementSelected: any,
) {
  image.onSelect = () => {
    openImageEditDrawer();
    !isReplacingImage.current && updateEditFormats({ eventAction: !firstElementSelected.current ? 'start' : 'add' });
    return false;
  };
}
